<div *transloco="let t;" class="row flex gap-5 pt-26 h-full onboarding" style="background-image: url('./assets/img/BG/BG-Onboarding.jpg');">
  <div class="col-lg-6 w-full md:w-1/2 col chat-container chat-container-column">
    <!-- <div class="chat-container chat-container-column"> -->
      <div class="chat-box flex-row first-block">
        <img src="./assets/img/Prof-light.png" class="prof" />
        <div class="chat-box-text">
          <h1 class="title-gradient gradient-pp uppercase">{{t('onboarding.findYourStarterEsc')}}</h1>
          <p>{{t('onboarding.companyConnectsTrainersInfo')}}</p>
        </div>
      </div>
      <div class="chat-box second-block">
        <p class="text-center">{{t('onboarding.krypDescriptionMsg')}}
          <br>
          {{t('onboarding.selectCombo')}}
        </p>
        <div class="card spec-selector">
          <div class="element-box">
            <div class="element-item" *ngFor="let el of elementsArray, let i = index"
              (click)="selectElement(el.type, i);" [ngClass]="{'selected':el.selected}">
              <img src="{{el.img}}">
              <p>{{el.type}}</p>
            </div>
          </div>
          <!--<div class="speciality-box">
            <div class="speciality-item" *ngFor="let sp of specialityArray, let i = index" (click)="selectSpeciality(sp.type,i)" [ngClass]="{'selected':sp.selected}">
               <h1>{{sp.type}}</h1>
            </div>
          </div>-->
        </div>
      </div>
    <!-- </div> -->
  </div>
  <div class="col-lg-6 w-full md:w-1/2 col card kryptomon-box">
    <!-- <div class="card kryptomon-box"> -->
      <div class="card-content" *ngIf="parsedKryptomon">
        <div class="card-img">
          <div class="image-block">
            <fa-icon [icon]="['fas', 'snowflake']" class="frozen-icon"
              *ngIf="foundKryptomon.nft.isFreezed==1"></fa-icon>
            <img src="{{foundKryptomon.nft.image}}" />
          </div>
          <div class="first-details">
            <div class="first-details-item">
              <h1>ID: {{foundKryptomon.nft.tokenId}}</h1>
              <div class="elements-icon">
                <div class="element-item">
                  <img src="{{foundKryptomon.nft.iconImage}}" />
                  <p>{{foundKryptomon.nft.elementType}}</p>
                </div>
                <div class="element-item">
                  <img src="{{foundKryptomon.nft.secondiconImage}}" />
                  <p>{{foundKryptomon.nft.elementTypeSecond}}</p>
                </div>
              </div>
              <div>
                {{t('shared.tier')}}: {{foundKryptomon.nft.stats.tier}} | {{t('shared.speciality')}}:
                {{foundKryptomon.nft.data.kryptomon.speciality}}
              </div>
            </div>
            <div class="price-tag">
              <p>${{foundKryptomon.order.priceUSD}}</p>
            </div>
          </div>
        </div>
        <div class="stat-content">
          <div class="stat-item">
            <p>{{foundKryptomon.nft.stats.physicalAttack.name}}</p>
            <div class="Stars" style="--rating: {{foundKryptomon.nft.stats.physicalAttack.stars}};">
            </div>
          </div>
          <div class="stat-item">
            <p>{{foundKryptomon.nft.stats.physicalDefense.name}}</p>
            <div class="Stars" style="--rating: {{foundKryptomon.nft.stats.physicalDefense.stars}};">
            </div>
          </div>
          <div class="stat-item">
            <p>{{foundKryptomon.nft.stats.mainElementalAttack.name}}</p>
            <div class="Stars" style="--rating: {{foundKryptomon.nft.stats.mainElementalAttack.stars}};">
            </div>
          </div>
          <div class="stat-item">
            <p>{{foundKryptomon.nft.stats.secondaryElementalAttack.name}}</p>
            <div class="Stars" style="--rating: {{foundKryptomon.nft.stats.secondaryElementalAttack.stars}};">
            </div>
          </div>
          <div class="stat-item">
            <p>{{foundKryptomon.nft.stats.elementalDefense.name}}</p>
            <div class="Stars" style="--rating: {{foundKryptomon.nft.stats.elementalDefense.stars}};">
            </div>
          </div>
          <div class="stat-item">
            <p>{{foundKryptomon.nft.stats.healthPoints.name}}</p>
            <div class="Stars" style="--rating: {{foundKryptomon.nft.stats.healthPoints.stars}};">
            </div>
          </div>
          <div class="stat-item">
            <p>{{foundKryptomon.nft.stats.critical.name}}</p>
            <div class="Stars" style="--rating: {{foundKryptomon.nft.stats.critical.stars}};">
            </div>
          </div>
          <div class="stat-item">
            <p>{{foundKryptomon.nft.stats.evasion.name}}</p>
            <div class="Stars" style="--rating: {{foundKryptomon.nft.stats.evasion.stars}};">
            </div>
          </div>
        </div>
        <div class="buttons">
          <div class="button-outline button-back" (click)="backKryptomon()" [ngClass]="{'hideButton':currentIndex==0}">
            <img src="./assets/img/Icon/Arrow-Back.svg" />{{t('shared.previous')}}
          </div>
          <div class="button-gradient" (click)="selectKryptomon()">{{t('shared.select')}}</div>
          <div class="button-outline button-next" (click)="nextKryptomon()"
            [ngClass]="{'hideButton':currentIndex==allKryptomons.length-1}">{{t('shared.next')}}<img
              src="./assets/img/Icon/Arrow-Next.svg" /></div>
        </div>

      </div>
      <div class="card-content h-full items-center flex loading-box" *ngIf="!parsedKryptomon">
        <div class="loading" *ngIf="isLoading">
          <fa-icon [icon]="['fas', 'spinner']" class="fa-spin"></fa-icon>
        </div>
        <div class="no-pars items-center flex flex-col" *ngIf="!isLoading && !noKryptomons">
          <img src="./assets/img/Icon/Loading.svg" />
          <h1>{{t('onboarding.kryptoFinderReady')}}</h1>
        </div>
        <div class="no-pars items-center flex flex-col" *ngIf="!isLoading && noKryptomons">
          <h1>{{t('onboarding.noCombination')}}</h1>
        </div>
      </div>
      <div class="paginationBlock" *ngIf="parsedKryptomon">
        <h1>{{currentIndex+1}} / {{allKryptomons.length}}</h1>
      </div>
    <!-- </div> -->
  </div>